// @flow

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import * as Sentry from '@sentry/react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { Suspense, lazy } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { Provider } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { ThemeProvider } from 'styled-components';

import config from './config/app.config.js';
import { BasePath } from './config/paths.js';
import useAnalytics from './hooks/useAnalytics';
import useTagManager from './hooks/useTagManager';
import { CheckDeposit } from './modules/checkdeposit';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { Header, Main, LayerError, LayerModal, GlobalLoading } from './modules/core';
import { FranceConnectDataCallback } from './modules/franceconnect';
import { PaypalDataCallback } from './modules/paypalconnect';
import { store } from './store/store';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import GlobalStyle, { gridTheme } from './styles/GlobalStyle';

const Styleguide = lazy(() => import('./modules/styleguide/components/Styleguide'));
const StepUserCreation = lazy(() =>
  import('./modules/step-user-creation/components/StepUserCreation'));
const Step2 = lazy(() => import('./modules/step2/components/Step2'));
const Step3 = lazy(() => import('./modules/step3/components/Step3'));
const Step4 = lazy(() => import('./modules/step4/components/Step4'));
const Step5 = lazy(() => import('./modules/step5/components/Step5'));
const Step6 = lazy(() => import('./modules/step6/components/Step6'));
const Step7 = lazy(() => import('./modules/step7/components/Step7'));
const Step8 = lazy(() => import('./modules/step8/components/Step8'));
const Step9 = lazy(() => import('./modules/step9/components/Step9'));
const Step10 = lazy(() => import('./modules/step10/components/Step10'));
const Step11 = lazy(() => import('./modules/step11/components/Step11'));
const Deposit = lazy(() => import('./modules/deposit/components/Deposit'));
const Limit = lazy(() => import('./modules/limit/components/Limit'));
const Paiement = lazy(() => import('./modules/paiement/components/Paiement'));
const RedirectStore = lazy(() => import('./modules/redirect/components/RedirectStore'));
const Landing = lazy(() => import('./modules/landing/components/Landing'));
const Pronos = lazy(() => import('./modules/pronos/components/Pronos'));
const App = lazy(() => import('./App'));
const Routes = lazy(() => import('./Routes'));

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const RooterRoutes = () => {
  useAnalytics();
  useTagManager();

  return (
    <Main>
      <LayerModal />
      <Header />
      <LayerError />
      <GlobalLoading />
      <Switch>
        <Route
          path={'/routes'}
          component={Routes}
        />
        <Route
          path={'/styleguide'}
          component={Styleguide}
        />
        <Route
          path={'/test'}
          component={App}
        />

        <Route
          path={'/redirect/store'}
          component={RedirectStore}
        />

        <Route
          exact
          path={'/step1/'}
          component={StepUserCreation}
        />
        <Route
          path={'/step1/:substep'}
          component={StepUserCreation}
        />

        <Route
          exact
          path={'/step2/'}
          component={Step2}
        />
        <Route
          path={'/step2/:substep'}
          component={Step2}
        />
        <Route
          path={'/data-callback'}
          component={FranceConnectDataCallback}
        />
        <Route
          path={'/callback/paypal'}
          component={PaypalDataCallback}
        />
        <Route
          exact
          path={'/step3/'}
          component={Step3}
        />

        <Route
          exact
          path={'/step4/'}
          component={Step4}
        />
        <Route
          path={'/step4/:substep'}
          component={Step4}
        />

        <Route
          exact
          path={'/step5/'}
          component={Step5}
        />
        <Route
          path={'/step5/:substep'}
          component={Step5}
        />

        <Route
          exact
          path={'/step6/'}
          component={Step6}
        />
        <Route
          path={'/step6/:substep'}
          component={Step6}
        />

        <Route
          exact
          path={'/step7/'}
          component={Step7}
        />
        <Route
          path={'/step7/:substep'}
          component={Step7}
        />

        <Route
          exact
          path={'/step8/'}
          component={Step8}
        />
        <Route
          path={'/step8/:substep'}
          component={Step8}
        />

        <Route
          exact
          path={'/step9/'}
          component={Step9}
        />
        <Route
          path={'/step9/:substep'}
          component={Step9}
        />

        <Route
          exact
          path={'/step10/'}
          component={Step10}
        />

        <Route
          exact
          path={'/step11/'}
          component={Step11}
        />

        <Route
          exact
          path={'/check-deposit/:depositId'}
          component={CheckDeposit}
        />

        <Route
          exact
          path={'/deposit/'}
          component={Deposit}
        />
        <Route
          path={'/deposit/:substep'}
          component={Deposit}
        />
        <Route
          exact
          path={'/limit/'}
          component={Limit}
        />
        <Route
          path={'/limit/:substep'}
          component={Limit}
        />
        <Route
          exact
          path={'/paiement/'}
          component={Paiement}
        />
        <Route
          path={'/paiement/:substep'}
          component={Paiement}
        />

        <Route
          path={'/landing/:name'}
          component={Landing}
        />
        <Route
          path={'/landing/'}
          component={Landing}
        />

        <Route
          path={'/pronos'}
          component={Pronos}
        />

        <Route
          exact
          path={'/'}
          component={StepUserCreation}
        />

        <Route
          exact
          path={'/*'}
          component={Landing}
        />
      </Switch>
    </Main>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const CaptchaProvider = ({ children }) => {
  if (config.shouldUseHcaptcha) {
    return children;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={config.recaptchaKey}>{children}</GoogleReCaptchaProvider>
  );
};

const Root = () => {
  return (
    <Suspense fallback={''}>
      <Router basename={BasePath}>
        <ThemeProvider theme={{ awesomegrid: gridTheme }}>
          <Provider store={store}>
            <GlobalStyle />
            <CaptchaProvider>
              <Sentry.ErrorBoundary fallback={'An error has occurred'}>
                <RooterRoutes />
              </Sentry.ErrorBoundary>
            </CaptchaProvider>
          </Provider>
        </ThemeProvider>
      </Router>
    </Suspense>
  );
};
export default Root;
